import adya_image from "../images/user_profile_pictures/adya.png";

export default function get_Picture(username) {
  let userImage = "";

  switch (username) {
    case "adya@hermes": {
      userImage = adya_image;
      break;
    }
    default: {
      userImage = adya_image;
      break;
    }
  }

  return userImage;
}
